import { CSSProperties } from "react";
import { Alert } from "swing-components";
import { generateSwingSupportURL } from "swing-utils";

import { translate } from "~utils";

type AlertErrorProps = {
  margin?: CSSProperties["margin"];
};

export function AlertError(props: AlertErrorProps) {
  const { margin } = props;
  return (
    <div style={{ margin: margin ? margin : "16px 0px" }}>
      <Alert color="danger" showIcon title={translate("LABEL_SOMETHING_WENT_WRONG")}>
        <span>
          {translate("LABEL_CONTACT_SUPPORT_1")}{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href={generateSwingSupportURL(translate("SWING_SUPPORT_LINK_GENERAL_REQUEST"))}
          >
            {translate("LABEL_CONTACT_SUPPORT")}
          </a>{" "}
          {translate("LABEL_CONTACT_SUPPORT_2")}
        </span>
      </Alert>
    </div>
  );
}
